require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./sciences-et-ingnierie-de-lenvironnement-2-1-3-10.json") })
        }
      }, "path---sciences-et-ingnierie-de-lenvironnement-2-1-3-10");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---sciences-et-ingnierie-de-lenvironnement-2-1-3-10!./.cache/json/sciences-et-ingnierie-de-lenvironnement-2-1-3-10.json
// module id = 560
// module chunks = 231608221292675